<template>
	<div class="rfmodel">
			
			
			<div id="referafriendpopup" title="Refer a friend"   ok-only   hide-header hide-footer no-close-on-backdrop size="sm" centered >
			
				
				<b-row class="offerP11">
					<b-col cols="12" class="text-center pt-2 pb-2">
							<h3 class=" font-bold  text-center text-3xl" style="font-weight: 800;">Refer a friend</h3>
							<p>and share Alluraa moments</p>
					</b-col>
					
					<b-col cols="12" class="text-center ">
							<b-row class="bgRed">
								<b-col  class="text-center firstP ">
									
									<h3 class="text-white font-bold  text-center text-3xl" style="font-weight: 800;"> Earn {{$root.currency()+''+$root.tofixed($root.REFER_AMOUNT, 0)}}</h3>
									<p class="text-white">for every referral</p>
								</b-col>
								<b-col  class="text-center secondP">
									<h3 class=" font-bold  text-center text-3xl" style="font-weight: 800;">+20% </h3>
									<p class="text-white">Cashback</p>
								</b-col>
							</b-row>
					</b-col>
					<span class="tandc">* T&C Apply</span>
				</b-row>
				
				
				
			  </div>
			

	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import '../assets/referafriendpopup.scss';

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	userData: { type: Array},	
  },
  mounted(){
    this.inLodcard();
	/*var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	} */
  },
  computed: {
    
  },
  data() {
    return{
		 coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
      urlprmoCoutUrl: this.$root.WEBAPI+'webapi/promotionCount',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			urlLink:'/login',
			myrole:0,
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		
		remindmelater(){
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			self.$session.set('remindmelater',1);
			self.$bvModal.hide('referafriendpopup');
			
				self.axios.post(self.urlprmoCoutUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : self.$root.customer_info.user_id
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 
						 console.log('count'); 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		}

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	
</style>
